import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";

import { decrypt } from "../../utils/encodingdecoding";
import { confirmEmail } from "../../actions/auth";
import swal from "sweetalert";

const Otp = () => {
    const {state}= useLocation();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [otp, setOtp] = useState("")
    console.log(state.userID)
   

    const handleClick = async () => {
        setLoader(true);
        const body = {
            otp:otp,
            userId:state?.userID
        };
        const response = await confirmEmail(body);
        if (response.message === "Sucess") {
            navigate("/signin");
            setLoader(false);
        } else {
            swal({
                title: " Oops!",
                text: "Invalid Otp",
                icon: "warning",
                button: "oh no!",
                timer: 5000,
            });
            setLoader(false);
        }
        setLoader(false);
    };

    return (
        <section className="section signUpPage newStyle">
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
           <div className="signUpPage__main" style={{ background: "none" }}>
                <div className="signUpPage__Boxed">
                    <div className="signUpPage__heading">
                        <h1>OTP Verification</h1>
                    </div>
                       

                        <div className="signUpPage__form">
                        <div className="signUpPage__formSection">
                        <div className="row">
                        <div className="col-md-12">
                            
                            <OtpInput value={otp} onChange={setOtp} numInputs={4} isInputNum 
                                            shouldAutoFocus   inputStyle={{
                                                width: '50px',
                                                height: '50px',
                                                margin: '5px',
                                                fontSize: '20px',
                                                borderRadius: '5px',
                                                border: '1px solid #ddd',
                                                textAlign: 'center',
                                                marginBottom:"20px"
                                            }} renderSeparator={<span>-</span>} renderInput={(props) => <input {...props} />} />
                          </div>
                            <div className="col-md-12">
                                    <div className="form-group">
                                        <button className="btn btn-primary btn-lg w-100" onClick={handleClick}>Submit</button>
                                    </div>
                                </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            
        </section>
    );
};

export default Otp;
